<!--预存模式配置-->
<template>
  <div>
    <a-modal v-model:visible="showConfigMode" title="预存模式配置"
             :keyboard="false"
             :mask="true"
             :maskClosable="false"
             :closable="false"
             :footer="slot"
    >
      <a-spin :spinning="loading">
        <a-form ref="formRef" :model="formState">
          <a-form-item label="预存模式" required  :rules="[{required: true, message: '必选项不允许为空'}]" v-bind="formItemLayout">
            <a-radio-group v-model:value="formState.mode">
              <a-radio value="1">项目模式</a-radio>
              <a-radio value="2">影院模式</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-form>
      </a-spin>
      <template #footer>
        <a-button key="custom" @click="onCancel">
          取消
        </a-button>
        <a-button key="custom" type="primary" @click="onOk">
          确定
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
  import {
    getSettingDetail, saveMode
  } from '@/service/modules/preStoreCenter.js';

  export default {
    props: {
      showConfigMode: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        formState: {},
        loading: false,
        test: true,
      }
    },
    created() {
      // this.getSettingDetail();
    },
    methods: {
      async getSettingDetail() {
        const ret = await getSettingDetail();
        if (ret.code == 200) {
          if (!Object.keys(ret.data).length) {
            this.showConfigMode = true;
          }
        }
      },
      onCancel() {
        this.$emit('close');
      },
      async onOk() {
        if (!this.formState.mode) {
          this.$message.error('请选择预存模式');
          return
        }
        this.$refs.formRef.validateFields().then(async () => {
          this.loading = true;
          const ret = await saveMode({
            preStorageMode: this.formState.mode
          });
          if (ret.code == 200) {
            this.$emit('onRefresh');
            this.$emit('onRefreshMode');
          }
          this.loading = false;
        })

      },
    },
  }
</script>
